import { render, staticRenderFns } from "./DenseExpansionPanel.vue?vue&type=template&id=620acf88&scoped=true"
var script = {}
import style0 from "./DenseExpansionPanel.vue?vue&type=style&index=0&id=620acf88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620acf88",
  null
  
)

export default component.exports